import styled from 'styled-components'

import { COLOURS } from 'resources'
import { ModalTitle } from 'components/ReklaimModal'
import RoundedButton from 'components/RoundedButton'

export const RedemptionRequirementContainer = styled.div`
  padding: 8px 0;
  display: flex;
  align-items: center;
`
export const RedemptionRequirementsModalTitle = styled(ModalTitle)`
  margin-bottom: 16px;
`
export const RedemptionRequirementText = styled.span`
  font-size: 18px;
`

export const RedemptionRequirementsFixLink = styled(RoundedButton)`
  display: inline;
  padding: 0 5px;
  background: none;
  border: none;
  color: ${COLOURS.textBlack};
  text-decoration: underline;
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;

  &:hover {
    text-decoration: none;
  }

  span {
    color: ${COLOURS.textBlack};
  }
`

export const Icon = styled.img`
  align-self: baseline;
  width: 24px;
  height: 24px;
  margin-right: 10px;
`
export const GotItButton = styled(RoundedButton)`
  width: 100%;
  margin-top: 28px;
`
